import { Base64 } from 'js-base64';
import * as type from './type-utils';

/**
 * 空函数, 用于默认赋值
 */
export function noop() {}

/**
 * 延迟, 用于 async await 等待
 * 用例:
 * (async ()=>{
 *   console.log('等待1s');
 *   await delay(1000);
 *   console.log('完成');
 * })();
 * @param ms
 */
export function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * 移除空白spaces
 * 输入: 137 2700 3240
 * 输出: 13727003240
 * @param text
 * @return {*}
 */
export function removeSpaces(text) {
  if (!text) {
    return text;
  }
  return text.replace(/\D+/g, '');
}

/**
 * 创建数组分组
 * @example
 * var arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
 * var groupedArr = createGroupedArray(arr, 4);
 * var result = JSON.stringify(groupedArr);
 * // result: "[[1,2,3,4],[5,6,7,8],[9,10,11,12],[13,14]]"
 * @return {Array}
 */
export function createGroupedArray(arr, chunkSize) {
  let groups = [],
    i = 0,
    arrLength = arr.length;
  for (; i < arrLength; i += chunkSize) {
    groups.push(arr.slice(i, i + chunkSize));
  }
  return groups;
}

/**
 * 仿 C# String.Format 实现
 * @example
 * 输入: stringFormat('{0} is dead, but {1} is alive!', 'ASP', 'ASP.NET');
 * 输出: ASP is dead, but ASP.NET is alive!
 * @param format
 * @return {*}
 */
export function stringFormat(format) {
  const args = Array.prototype.slice.call(arguments, 1);
  return format.replace(/{(\d+)}/g, function(match, number) {
    return typeof args[number] !== 'undefined' ? args[number] : match;
  });
}

/**
 * 对象转换成 json string
 * @param input
 * @return {*}
 */
function object2JSONString(input) {
  if (!type.isNullOrUndefined(input)) {
    let str = input;
    if (type.isObjectLike(str) || type.isString(str)) {
      str = JSON.stringify(str);
      return str;
    }
  }
  throw new Error('the type of input should be {object} or {string}');
}

/**
 * base 64 url 编码
 * @param input
 */
export function base64UrlEncode(input) {
  const str = object2JSONString(input);
  return Base64.toBase64(str, true);
}

/**
 * base 64 url 解码
 * @param str
 * @param jsonParse
 * @return {*}
 */
export function base64UrlDecode(str, jsonParse = true) {
  const result = Base64.fromBase64(str);
  if (jsonParse) {
    return JSON.parse(result);
  }
  return result;
}

export function transformObjectToSearchString(obj) {
  return Object.keys(obj)
    .reduce((str, currentKey) => (str += `${currentKey}=${encodeURIComponent(obj[currentKey])}&`), '?')
    .slice(0, -1);
}

/* 模拟a标签跳转
 * @param url
 * @param target
 * @return {*}
 */
export function aLink(url, target = '_blank') {
  const a = document.createElement('a');
  a.href = url;
  a.target = target;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
/**
 * 页面跳转
 */
export function jumpPage(url, params = null, newStatus = false) {
  let fullPath = window.location.origin + window.location.pathname;
  // TODO TEST
  // let fullPath = 'https://test-zt.xoyo.games/mechabreak.seasungames.com/p/zt/2025/03/21/index/ja';
  let urlWithoutFileName = fullPath.replace(/\/[^\/]+\.html$/, '/');
  // 如果路径末尾没有斜杠，则添加斜杠（可选）
  if (!urlWithoutFileName.endsWith('/')) {
    urlWithoutFileName += '/';
  }
  let nextUrl = urlWithoutFileName + url;
  if (params) {
    nextUrl += `${params}`;
  }

  if (newStatus) {
    aLink(nextUrl);
  } else {
    window.location.href = nextUrl;
  }
}

export const isTablet = () => {
  // 判断屏幕宽度（主流平板宽度在 768px ~ 1024px 之间）
  const screenWidth = window.innerWidth;
  const isTabletSize = screenWidth >= 768 && screenWidth <= 1024;

  // UA 检测常见平板设备
  const userAgent = navigator.userAgent.toLowerCase();
  const isIPad =
    /ipad/.test(userAgent) ||
    // iPad Pro 可能被识别为 Mac，需额外判断触摸支持
    (/macintosh/.test(userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
  const isAndroidTablet = /android/.test(userAgent) && !/mobile/.test(userAgent);
  return isTabletSize || isIPad || isAndroidTablet;
};
